// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2o0my","title":"styles_title__1JNN1"};